module.exports = __webpack_public_path__ + "static/media/swivel-knive-leatherworking-tool.b75317e7.webp";